/* Gérard Taurin — Homepage sections (Andaman 1.3.0) */
(function () {
  'use strict';

  // Le script est inclus par chaque section gt-* : on ne l'exécute qu'une fois.
  if (window.__gtHomeLoaded) return;
  window.__gtHomeLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  /* ---------- Apparition au scroll ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.gt-reveal:not(.is-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    // Les éléments déjà dans le viewport sont affichés tout de suite (pas de flash au chargement).
    var vh = window.innerHeight;
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add('is-visible');
    });
    document.documentElement.classList.add('gt-anim');

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    items.forEach(function (el) {
      if (!el.classList.contains('is-visible')) observer.observe(el);
    });
  }

  /* ---------- Boutiques : liste <-> pins de la carte ---------- */
  function initStores(root) {
    (root || document).querySelectorAll('[data-gt-stores]').forEach(function (section) {
      if (section.dataset.gtReady) return;
      section.dataset.gtReady = '1';

      var triggers = section.querySelectorAll('[data-gt-store]');
      var pins = section.querySelectorAll('[data-gt-pin]');

      function activate(index) {
        section.querySelectorAll('.gt-store[data-gt-store]').forEach(function (btn) {
          btn.setAttribute('aria-current', btn.dataset.gtStore === index ? 'true' : 'false');
        });
        pins.forEach(function (pin) {
          pin.toggleAttribute('data-active', pin.dataset.gtPin === index);
        });
      }

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () { activate(btn.dataset.gtStore); });
      });
    });
  }

  /* ---------- Newsletter -> webhook n8n (liste Odoo), avec contrôle anti-robots ---------- */
  function initNewsletter(root) {
    (root || document).querySelectorAll('[data-gt-newsletter]').forEach(function (form) {
      if (form.dataset.gtReady) return;
      form.dataset.gtReady = '1';
      var startedAt = Date.now();
      var success = form.querySelector('[data-gt-success]');
      var error = form.querySelector('[data-gt-error]');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var honeypot = form.querySelector('input[name="contact_phone"]');
        error.hidden = true;

        if (honeypot && honeypot.value.trim() !== '') return;
        if (Date.now() - startedAt < 800) return;
        if (!input.checkValidity()) {
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          return;
        }
        input.removeAttribute('aria-invalid');
        form.classList.add('is-loading');

        fetch(form.dataset.gtNewsletter, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: input.value.trim(), contact_phone: honeypot ? honeypot.value : '' })
        }).then(function (response) {
          if (!response.ok) throw new Error(response.status);
          form.querySelector('.gt-newsletter__field').hidden = true;
          success.hidden = false;
        }).catch(function () {
          error.hidden = false;
        }).then(function () {
          form.classList.remove('is-loading');
        });
      });
    });
  }

  /* ---------- Footer : rubriques ouvertes sur ordinateur, repliées sur mobile ---------- */
  var footerQuery = window.matchMedia('(max-width: 749px)');
  function syncFooterColumns(root) {
    (root || document).querySelectorAll('.gt-footer__column').forEach(function (column) {
      column.open = !footerQuery.matches;
    });
  }
  if (footerQuery.addEventListener) {
    footerQuery.addEventListener('change', function () { syncFooterColumns(document); });
  }

  /* ---------- Pages légales : impression, sommaire actif, sommaire replié sur mobile ---------- */
  var legalQuery = window.matchMedia('(max-width: 989px)');
  function initLegal(root) {
    (root || document).querySelectorAll('[data-gt-legal]').forEach(function (legal) {
      if (legal.dataset.gtReady) return;
      legal.dataset.gtReady = '1';

      var printButton = legal.querySelector('[data-gt-print]');
      if (printButton) printButton.addEventListener('click', function () { window.print(); });

      var toc = legal.querySelector('.gt-legal__toc');
      var links = legal.querySelectorAll('[data-gt-toc-link]');
      if (!toc || !links.length) return;

      if (legalQuery.matches) toc.open = false;
      links.forEach(function (link) {
        link.addEventListener('click', function () { if (legalQuery.matches) toc.open = false; });
      });

      if (!('IntersectionObserver' in window)) return;
      var byId = {};
      links.forEach(function (link) { byId[link.getAttribute('href').slice(1)] = link; });
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (link) { link.removeAttribute('aria-current'); });
          var active = byId[entry.target.id];
          if (active) active.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      legal.querySelectorAll('.gt-legal__article').forEach(function (article) { spy.observe(article); });
    });
  }

  /* ---------- Politiques Shopify (/policies/...) : même mise en page que les pages légales ----------
     Ces pages sont générées par Shopify (pas de modèle possible) : on réorganise le HTML côté navigateur. */
  function initPolicy() {
    var policy = document.querySelector('.shopify-policy__container');
    if (!policy || policy.dataset.gtReady) return;
    policy.dataset.gtReady = '1';

    var rte = policy.querySelector('.shopify-policy__body .rte') || policy.querySelector('.shopify-policy__body');
    if (!rte) return;
    var titleNode = policy.querySelector('.shopify-policy__title');
    var title = titleNode ? titleNode.textContent.trim() : document.title;

    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    }

    var root = el('div', 'gt-section gt-legal gt-legal--policy');
    root.id = 'gt-legal-policy';
    root.setAttribute('data-gt-legal', '');

    var hero = el('header', 'gt-legal__hero');
    var heroInner = el('div', 'gt-container gt-legal__hero-inner');
    heroInner.appendChild(el('p', 'gt-kicker', 'Informations légales'));
    heroInner.appendChild(el('h1', 'gt-title', title));

    var nodes = Array.prototype.slice.call(rte.childNodes);
    var firstP = rte.querySelector(':scope > p');
    if (firstP && /mise à jour/i.test(firstP.textContent)) {
      heroInner.appendChild(el('p', 'gt-legal__meta', firstP.textContent.trim()));
      nodes = nodes.filter(function (n) { return n !== firstP; });
    }
    var printButton = el('button', 'gt-legal__print', 'Imprimer / PDF');
    printButton.type = 'button';
    printButton.setAttribute('data-gt-print', '');
    heroInner.appendChild(printButton);
    hero.appendChild(heroInner);
    root.appendChild(hero);

    var layout = el('div', 'gt-container gt-legal__layout');
    var content = el('article', 'gt-legal__content');
    var intro = el('div', 'gt-legal__intro');
    var list = el('ol', 'gt-legal__toc-list');
    list.setAttribute('role', 'list');
    var current = null;
    var count = 0;

    nodes.forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'H2') {
        count += 1;
        var section = el('section', 'gt-legal__article');
        section.id = 'article-' + count;
        var heading = el('h2', 'gt-legal__heading');
        heading.appendChild(el('span', '', node.textContent.trim()));
        section.appendChild(heading);
        current = el('div', 'gt-legal__body');
        section.appendChild(current);
        content.appendChild(section);

        var item = el('li');
        var link = el('a', '', node.textContent.trim());
        link.href = '#article-' + count;
        link.setAttribute('data-gt-toc-link', '');
        item.appendChild(link);
        list.appendChild(item);
      } else if (node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim())) {
        (current || intro).appendChild(node);
      }
    });

    if (intro.childNodes.length) content.insertBefore(intro, content.firstChild);

    if (count >= 2) {
      var aside = el('aside', 'gt-legal__aside');
      var toc = el('details', 'gt-legal__toc');
      toc.open = true;
      var summary = el('summary', 'gt-legal__toc-title', 'Sommaire');
      var toggle = el('span', 'gt-footer__toggle');
      toggle.setAttribute('aria-hidden', 'true');
      summary.appendChild(toggle);
      toc.appendChild(summary);
      toc.appendChild(list);
      aside.appendChild(toc);
      layout.appendChild(aside);
    } else {
      layout.classList.add('gt-legal__layout--single');
    }

    var top = el('p', 'gt-legal__top');
    var topLink = el('a', '', '↑ Retour en haut');
    topLink.href = '#gt-legal-policy';
    top.appendChild(topLink);
    content.appendChild(top);

    layout.appendChild(content);
    root.appendChild(layout);
    policy.parentNode.replaceChild(root, policy);
  }

  /* ---------- Panier Andaman (BarracudaCart) ----------
     Le thème branche automatiquement les boutons .barracuda-cart-addToCartButton
     présents au chargement. Après un rechargement de section dans l'éditeur,
     on les rebranche si l'instance est accessible. */
  function bindCartButtons(root) {
    var cart = window.barracudaCart;
    if (!cart || typeof cart.appendAddToCartButton !== 'function') return;
    root.querySelectorAll('.barracuda-cart-addToCartButton').forEach(function (btn) {
      cart.appendAddToCartButton(btn);
    });
  }

  function init(root) {
    initPolicy();
    initReveal(root);
    initStores(root);
    initNewsletter(root);
    syncFooterColumns(root);
    initLegal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* ---------- Éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    bindCartButtons(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var btn = event.target.querySelector && event.target.querySelector('.gt-store[data-gt-store]');
    if (btn) btn.click();
    var reveal = event.target.closest && event.target.closest('.gt-reveal');
    if (reveal) reveal.classList.add('is-visible');
  });
})();
